<template>
  <div class="text-start px-2">
    <div class="fs-4 my-2">مشاهده اطلاعات تیم</div>
    <div class="row py-3">
      <div class="col fs-5 text-primary">
        نام تیم :
        {{ teamInfo.name }}
      </div>
    </div>

    <table class="table table-hover table-responsive table-striped">
      <thead>
        <tr>
          <th>ردیف</th>
          <th>نام</th>
          <th>تلفن</th>
          <th>سمت</th>
          <th>وضعیت</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>
            {{
              (teamInfo.leader.first_name || "") +
              " " +
              teamInfo.leader.last_name
            }}
          </td>
          <td>
            {{ teamInfo.leader.email }}
          </td>
          <td>سازنده تیم</td>
          <td>
            <span>
              تایید شده
              <i class="fas fa-check me-1 text-success"></i>
            </span>
          </td>
        </tr>
        <tr v-for="(item, index) in teamInfo.team_member" :key="item.id">
          <td>{{ index + 2 }}</td>
          <td>
            {{
              item.member
                ? (item.member.first_name || "") + " " + item.member.last_name
                : "---"
            }}
          </td>
          <td>{{ item.mobile }}</td>
          <td>عضو تیم</td>
          <td>
            <span v-if="item.is_verified">
              تایید شده
              <i class="fas fa-check me-1 text-success"></i>
            </span>
            <span v-else>
              در انتظار تایید
              <i class="fas fa-window-close text-danger"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="teamOk" class="bg-success p-2 text-white">
      گروه شما تایید شده است و کلاس برای شما باز گردید.
    </div>
    <div v-else class="bg-warning p-2">
      پس از تایید همه اعضا تیم شما مورد تایید قرار خواهد گرفت وکلاس برای شما باز
      خواهد شد.
    </div>
  </div>
</template>
<script>
export default {
  props: {
    teamInfo: {
      type: Object,
    },
  },
  computed: {
    teamOk() {
      for (const i in this.teamInfo.team_member) {
        if (this.teamInfo.team_member[i].is_verified === 0) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>